import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ContextSelectorService } from '../../services/context-selector.service';

export const orgContextInterceptor: HttpInterceptorFn = (req, next) => {
  const contextService = inject(ContextSelectorService);

  let headers = req.headers;
  const tenantId = contextService.selectedTenantId;
  // Một Guid, hoặc danh sách Guid ngăn dấu phẩy khi panel bối cảnh chọn NHIỀU (máy chủ tự mở
  // rộng cây con của mỗi đơn vị). Xem ContextSelectorService.businessUnitContextHeader.
  const buId = contextService.businessUnitContextHeader;
  const facilityId = contextService.facilityContextHeader;

  // Backend TenantContextMiddleware reads tenant from JWT claim → X-Tenant-Id header → ?tenantId (dev).
  // For sessions whose token carries no tenant_id claim (e.g. SUPER ADMIN), this header is what binds
  // the picked "Đơn vị thuế" tenant to every API call — without it the API 403s TENANT_CONTEXT_MISSING.
  if (tenantId) {
    headers = headers.set('X-Tenant-Id', tenantId);
  }
  if (buId) {
    headers = headers.set('X-BusinessUnit-Context', buId);
  }
  if (facilityId) {
    headers = headers.set('X-Facility-Context', facilityId);
  }

  return next(req.clone({ headers }));
};
